"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _utils = require("../../../utils");

var _flashInput = _interopRequireDefault(require("../utils/flashInput"));

require("../styles/_header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var HEADER_CLASS = 'video-tool-header';

function focusRenameInput() {
  return _focusRenameInput.apply(this, arguments);
}

function _focusRenameInput() {
  _focusRenameInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var input;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            input = document.querySelector(".".concat(HEADER_CLASS, " .title-input > input"));

            if (input) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.resolve());

          case 3:
            input.focus();
            _context.next = 6;
            return (0, _flashInput.default)(input);

          case 6:
            return _context.abrupt("return", (0, _flashInput.default)(input, {
              withInitialDelay: true
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _focusRenameInput.apply(this, arguments);
}

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "updateName", function (_ref) {
      var value = _ref.target.value;
      var canUpdateVideo = _this.props.canUpdateVideo;

      if (canUpdateVideo) {
        _this.setState({
          name: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveName", function () {
      var name = _this.state.name;
      var _this$props = _this.props,
          onUpdateVideo = _this$props.onUpdateVideo,
          canUpdateVideo = _this$props.canUpdateVideo;

      if (canUpdateVideo) {
        onUpdateVideo({
          name: name
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getStageValidity", (0, _memoizeOne.default)(function () {
      var video = _this.props.video;
      return [true, // Add extra boolean to allow us to reference index as stage number
      true, (0, _utils.isValidStage)(2, video), (0, _utils.isValidStage)(3, video), (0, _utils.isValidStage)(4, video), (0, _utils.isValidStage)(5, video)];
    }));

    _this.state = {
      name: props.name || ''
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          fetchCollaborationData = _this$props2.fetchCollaborationData,
          organisationId = _this$props2.organisationId;
      fetchCollaborationData(organisationId);
    }
  }, {
    key: "render",
    value: function render() {
      var name = this.state.name;
      var _this$props3 = this.props,
          currentStage = _this$props3.currentStage,
          onClickStage = _this$props3.onClickStage,
          drawerRef = _this$props3.drawerRef,
          saving = _this$props3.saving,
          canUpdateVideo = _this$props3.canUpdateVideo,
          videoPermissions = _this$props3.videoPermissions,
          projectName = _this$props3.projectName,
          onSave = _this$props3.onSave,
          selectedClips = _this$props3.selectedClips,
          orderedClips = _this$props3.orderedClips,
          video = _this$props3.video;
      var actionOptions = [{
        action: (0, _utils.openDrawerTab)(drawerRef, 0),
        label: 'VIEW DETAILS',
        requiredPermission: 'READ'
      }];
      var options = canUpdateVideo ? [].concat(actionOptions, [{
        action: focusRenameInput,
        label: 'RENAME VIDEO',
        requiredPermission: 'UPDATE'
      }]) : actionOptions;
      var selectedClipsLabel = selectedClips ? "(".concat(selectedClips, ")") : '';
      var orderedClipsLabel = orderedClips ? "(".concat(orderedClips, ")") : '';
      var stageValidity = this.getStageValidity(video);
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: HEADER_CLASS
        }, /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationPageHeader, {
          editableTitle: canUpdateVideo,
          title: name,
          subtitle: projectName,
          actionBtnText: canUpdateVideo ? 'Save & Close' : 'Close',
          actionBtnMobileIcon: "close",
          actionPopupOptions: options.filter(function (_ref2) {
            var requiredPermission = _ref2.requiredPermission;
            return (0, _commonReact.hasPermission)(requiredPermission, videoPermissions);
          }),
          onChangeTitle: this.updateName,
          onBlurTitle: this.saveName,
          actionPopupBackgroundColor: "tundora",
          actionBtnOnClick: onSave,
          actionBtnBusy: saving,
          darkMode: true
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Stages, {
          onClick: onClickStage,
          currentStage: currentStage,
          stages: [{
            text: "select footage ".concat(selectedClipsLabel),
            minText: "select ".concat(selectedClipsLabel)
          }, {
            text: "arrange footage ".concat(orderedClipsLabel),
            minText: "arrange ".concat(orderedClipsLabel),
            disabled: !stageValidity[2]
          }, {
            text: 'brief the editor',
            minText: 'brief',
            disabled: !stageValidity[3]
          }, {
            text: 'add-ons & extra',
            minText: 'extras',
            disabled: !stageValidity[4]
          }, {
            text: 'confirm & submit',
            minText: 'submit',
            disabled: !stageValidity[5]
          }]
        }))
      );
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;